import ClientParser from '../../lib/client/html-to-dom.js';

export default ClientParser.default;
